import React from "react";

/** External libraries */
import { Button } from "@npm-telluria-tecnologia/telluria-ui";

/** Molecules */
import { ModalFormDialog } from "@molecules/index";

/** Languages */
import useTranslation from "@languages/useTranslation";
import { ExpiredSessionMessages } from "@languages/interfaces";

/** Styled components */
import * as Styled from "./styles";

/** Component */
const ExpiredSession: React.FC = () => {

  const { t } = useTranslation();

  const handleRedirectLogin = () => {
    window.location.href = "/";
  };

  return (
    <Styled.Container>
      <ModalFormDialog
        title={t(ExpiredSessionMessages.formDialogTitle)}
        open
      >
        <Styled.Content>
          <div className="text">{t(ExpiredSessionMessages.formDialogContent)}</div>
          <Button
            text={t(ExpiredSessionMessages.formDialogActionText)}
            className="default-submit-button"
            onClick={handleRedirectLogin}
          />
        </Styled.Content>
      </ModalFormDialog>
    </Styled.Container>
  );
};

export default ExpiredSession;
